// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-name{background:none;border:none}.tpss{line-height:unset!important}.cls-tabs-navs.newPosition .el-tabs__item{transition:all .3s;border-bottom:2px solid transparent}.cls-tabs-navs.newPosition .el-tabs__item.is-active{border-bottom:2px solid #5088ff}.cls-tabs-navs.newPosition .el-tabs__active-bar{display:none}", ""]);
// Exports
module.exports = exports;
